<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline mb-4">Total Policies</div>
              <v-list-item-title class="text-h5 mb-1">{{ stats.total_policies }}</v-list-item-title>
              <v-list-item-subtitle>Year: 2026</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar tile size="80" color="blue lighten-4">
               <v-icon color="blue" x-large>mdi-file-document-multiple</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline mb-4">Insured Area (Mu)</div>
              <v-list-item-title class="text-h5 mb-1">{{ stats.total_area ? stats.total_area.toFixed(2) : '0.00' }}</v-list-item-title>
              <v-list-item-subtitle>Verified</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar tile size="80" color="green lighten-4">
               <v-icon color="green" x-large>mdi-image-area</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline mb-4">Total Premium (¥)</div>
              <v-list-item-title class="text-h5 mb-1">{{ stats.total_premium ? stats.total_premium.toFixed(2) : '0.00' }}</v-list-item-title>
              <v-list-item-subtitle>Estimated</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar tile size="80" color="orange lighten-4">
               <v-icon color="orange" x-large>mdi-currency-cny</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>

       <v-col cols="12" sm="6" md="3">
        <v-card outlined>
          <v-list-item three-line>
             <v-list-item-content>
                <div class="text-overline mb-1">Status</div>
                <div v-for="s in stats.status_distribution" :key="s.label" class="d-flex justify-space-between" style="width: 100%">
                   <span class="text-caption">{{s.label}}</span>
                   <span class="text-caption font-weight-bold">{{s.count}}</span>
                </div>
             </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  name: 'StatsPanel',
  data () {
    return {
      stats: {
        total_policies: 0,
        total_area: 0,
        total_premium: 0,
        status_distribution: []
      }
    }
  },
  mounted () {
    this.refresh();
  },
  methods: {
    async refresh () {
      try {
        const res = await axios.get('/stats/dashboard', { params: { year: 2026 } });
        this.stats = res.data;
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>
